define('MM/Models/ContentSearch/FacetHierarchyChoiceValue',["jquery", "knockout", "score_bootstrap/Models/SitecoreId"], function ($, ko, SitecoreId) {
    "use strict";

    function FacetHierarchyChoiceValue(id, value, text, scope, isPreselected, $dropDownButton) {
        Object.defineProperty(this, 'scope', {value: scope, enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, 'id', {value: SitecoreId.parse(id), enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, 'value', {value: value, enumerable: !0, configurable: !0, writable: !0});
        Object.defineProperty(this, 'text', {value: text, enumerable: !0, configurable: !0, writable: !0});
        Object.defineProperty(this, 'selected', {value: ko.observable(isPreselected), enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, 'count', {value: ko.observable(0), enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, 'expanded', {value: ko.observable(!1), enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, '$panel', {value: $dropDownButton, enumerable: !0, configurable: !0, writable: !1});
        Object.defineProperty(this, 'isPartialSelected', { value: ko.observable(!1), enumerable: !0, configurable: !0, writable: !1});

        Object.defineProperty(this, 'selectedRegionsCount', {value: $dropDownButton, enumerable: !0, configurable: !0, writable: !1, value: ko.observable(0) });
        Object.defineProperty(this, 'selectedMarketsCount', {value: $dropDownButton, enumerable: !0, configurable: !0, writable: !1, value: ko.observable(0) });
        

        
        this.disabled = ko.computed(this._disabledStateCheck, this);

        ko.applyBindings(this, this.scope);
    }

    FacetHierarchyChoiceValue.prototype._recalculatePartialSelection = function _recalculatePartialSelection(){
        var children = [].slice.call(this.scope.querySelectorAll(':scope .score-facet-row-submenu .js-row > input[type=checkbox]'));
        var hasUnchecked = children.length && children.some(function (checkbox) { return !checkbox.checked; });

        console.log('recalculate');

        this.isPartialSelected(hasUnchecked);
    }

    FacetHierarchyChoiceValue.prototype._calculateSelectedRegions = function _calculateSelectedRegions() {
        if(!this.selected()) {
            this.selectedRegionsCount(0);
            this.selectedMarketsCount(0);
        }
        
        // regions can be calculated only to an item which is the top level, we should skip calculation for children
        var isRegionsCalculatable = this.scope.closest('.js-row') == null;
        if(!isRegionsCalculatable) {
            this.selectedRegionsCount(0);
            this.selectedMarketsCount(0);
        }


        // only elements with two level nesting might have regions
        var isThreeLevelNesting = this.scope.querySelector(':scope > .score-facet-row-submenu > .js-row > .score-facet-row-submenu > .js-row');

        var selectedRegions = [];
        var selectedMarkets = [];
        if(isThreeLevelNesting) {
            selectedRegions = [].slice.call(this.scope.querySelectorAll(':scope > .score-facet-row-submenu > .js-row > input[type=checkbox]:checked'));
            selectedMarkets = [].slice.call(this.scope.querySelectorAll(':scope > .score-facet-row-submenu > .js-row > .score-facet-row-submenu > .js-row > input[type=checkbox]:checked'));
        } else {
            // if only two levels nesting, then that is probably Canada and it has just Markets;
            selectedRegions = [];
            selectedMarkets = [].slice.call(this.scope.querySelectorAll(':scope > .score-facet-row-submenu > .js-row > input[type=checkbox]:checked'));
        }

        this.selectedRegionsCount(selectedRegions.length);
        this.selectedMarketsCount(selectedMarkets.length);
    }

    FacetHierarchyChoiceValue.prototype.subscribeToChildrenLevelSelectionChanged = function subscribeToChildrenLevelSelectionChanged() {
        // we have to subscribe to children event notifications later then the parent component, 
        // otherwise we will fail on recalculation of selection because the parent is responsible for that
        [this.scope].concat([].slice.call(this.scope.querySelectorAll('.js-row'))).forEach(function(el) {
            el.addEventListener('levelSelectionChanged', this._calculateSelectedRegions.bind(this));
            el.addEventListener('levelSelectionChanged', this._recalculatePartialSelection.bind(this));
        }, this);
    }


    FacetHierarchyChoiceValue.prototype._disabledStateCheck = function _disabledStateCheck() {
        // was found the only way how to trigger event to update UI regarding selected and enabled list options based on retrieved from server-side data.   
        this.$panel.triggerHandler("FacetHierarchyChoiceValue:disabled:checking");
        // facetContainer in "reset" method pass the count as a string, so we should make sure to convert it to a proper type
        return !this.selected() && (this.count()|0) === 0;
    }

    FacetHierarchyChoiceValue.prototype.resetCount = function resetCount() {
        this.count(0);
    }

    FacetHierarchyChoiceValue.prototype.userInteraction = function userInteraction(entity, e) {
        var event = document.createEvent('Event');
        event.initEvent('levelSelectionChanged', false, true);
        entity.scope.dispatchEvent(event);

        e.stopPropagation();

        // we need to return true so the default action will be proceed.
        return!0; 
    }

    FacetHierarchyChoiceValue.prototype.preventDropdownClose = function preventDropdownClose(entity, e) {
        // prevent closing of the dropdown.
        e.stopPropagation();
        // return true so selection will happen.
        return!0;
    }

    FacetHierarchyChoiceValue.prototype.toggleLevel = function toggleLevel(vm, ev) {
        this.expanded(!this.expanded());

        // stop event, so dropdown won't be closed
        ev.stopPropagation();
    }

    return FacetHierarchyChoiceValue;
});
